<template>
  <div class="app-modal">
    <div class="modal-content">
      <div class="header">
        <img class="close-mobile" src="@/assets/app-icons/profile/back.svg" @click="$emit('closeArrivalModal')" />
        <span class="subtitle">Prijavi termin dolaska</span>
        <span class="close" @click="$emit('closeArrivalModal')"></span>
      </div>
      <p class="description">
        Za dolazak na konferenciju potrebna je prijava. Odaberi svoj termin kako bismo se pobrinuli da se poštuju sve
        epidemiološke mjere.
        <br />
        Možeš prijaviti samo jedan termin.
      </p>
      <h3 class="undertitle" v-if="distinctDays.length">Odaberi dan</h3>
      <div class="arrival-time-periods__days">
        <button
          v-for="(distinctDay, index) in distinctDays"
          v-bind:key="index"
          v-on:click="setActiveArrivalTimeSlotDay(distinctDay)"
          v-bind:class="{ selected: distinctDay.dayNumber === activeDay }"
        >
          <div class="day-number">{{ distinctDay.dayNumber }}.</div>
          <p class="day-string">{{ distinctDay.dayString }}</p>
        </button>
      </div>
      <h3 class="undertitle" v-if="distinctDays.length">Odaberi vrijeme</h3>
      <div class="arrival-time-periods__slots" v-for="(distinctDay, index) in distinctDays" v-bind:key="index">
        <button
          v-show="distinctDay.dayNumber === activeDay"
          v-for="arrivalTimeSlot in activeTimeSlots(distinctDay.dayNumber)"
          v-bind:key="arrivalTimeSlot.id"
          v-on:click="chooseTimeSlot(arrivalTimeSlot)"
          v-bind:disabled="!arrivalTimeSlot.isTimeSlotAvailable"
        >
          <div class="arrival-info">
            <div class="time">
              {{ getFormattedDate(arrivalTimeSlot.startOfTimeSlot) }} -
              {{ getFormattedDate(arrivalTimeSlot.endOfTimeSlot) }}
            </div>
            <div class="amount">
              {{
                arrivalTimeSlot.id === arrivalTimeSlotSelectedId
                  ? arrivalTimeSlot.numberOfAttendees
                  : arrivalTimeSlot.numberOfAttendees
              }}/{{ arrivalTimeSlot.timeSlotCapacity }}
            </div>
          </div>
          <div class="arrival-mark" v-bind:class="{ checked: arrivalTimeSlot.id === arrivalTimeSlotSelectedId }"></div>
        </button>
      </div>

      <div class="result--error" v-bind:style="{ visibility: isArrivalTimeSlotsEmpty ? 'visible' : 'hidden' }">
        Nažalost nema ponuđenih vremena dolaska
      </div>
      <div class="result--error" v-bind:style="{ visibility: changeWasntSuccessful ? 'visible' : 'hidden' }">
        Zahtjev za promjenom neuspješan. Molimo te pokušaj ponovo.
      </div>
      <div class="result--success" v-bind:style="{ visibility: isSuccessfullyConfirmed ? 'visible' : 'hidden' }">
        Uspješno potvrđen termin
      </div>
      <div class="actions">
        <button class="confirm-button" v-on:click="confirmArrival()" v-bind:disabled="isSubmitDisabled">
          Prijavi termin
        </button>
      </div>
    </div>
    <a aria-label="Zatvori popup" class="backdrop" v-on:click="$emit('closeArrivalModal')"></a>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'ArrivalTimePickerModal',
  data() {
    return {
      distinctDays: [],
      activeDay: null,
      arrivalTimeSlots: [],
      arrivalTimeSlotSelectedId: null,
      isArrivalTimeSlotsEmpty: false,
      changeWasntSuccessful: false,
      isSuccessfullyConfirmed: false,
    };
  },
  computed: {
    isSubmitDisabled: function () {
      return !this.arrivalTimeSlotSelectedId;
    },
  },
  methods: {
    setActiveArrivalTimeSlotDay: function (day) {
      this.activeDay = day.dayNumber;
      this.arrivalTimeSlotSelectedId = null;
    },
    getFormattedDate: function (date) {
      return moment(date).format('HH:mm');
    },
    chooseTimeSlot: function (timeSlot) {
      this.arrivalTimeSlotSelectedId = timeSlot.id;
    },
    activeTimeSlots: function (day) {
      return this.arrivalTimeSlots.filter(
        arrivalTimeSlot => new Date(arrivalTimeSlot.startOfTimeSlot).getDate() === +day,
      );
    },
    confirmArrival: function () {
      this.$axios
        .post(`${this.$API_URL}/user/confirm-arrival`, { timeSlotId: this.arrivalTimeSlotSelectedId })
        .then(() => {
          this.isSuccessfullyConfirmed = true;
          setTimeout(() => {
            this.isSuccessfullyConfirmed = false;
            this.$emit('saveArrivalModal');
          }, 1000);
        });
    },
    getDayString(dayNumber) {
      switch (dayNumber) {
        case 1:
          return 'Ponedjeljak';
        case 2:
          return 'Utorak';
        case 3:
          return 'Srijeda';
        case 4:
          return 'Četvrtak';
        case 5:
          return 'Petak';
        case 6:
          return 'Subota';
        case 7:
          return 'Nedjelja';
      }
    },
  },
  created() {
    this.$axios.get(`${this.$API_URL}/arrival-time-slots`).then(response => {
      this.isArrivalTimeSlotsEmpty = response && response.data && response.data.length === 0;
      if (this.isArrivalTimeSlotsEmpty) {
        return;
      }
      const filtered = [
        ...new Set(
          response.data.map(arrivalTimeSlot => {
            const date = new Date(arrivalTimeSlot.startOfTimeSlot);

            return `${date.getDate()}-${this.getDayString(date.getDay())}`;
          }),
        ),
      ];

      this.distinctDays = filtered
        .map(string => {
          const split = string.split('-');

          return {
            dayNumber: split[0],
            dayString: split[1],
          };
        })
        .sort((a, b) => a.dayNumber - b.dayNumber);

      this.activeDay = this.distinctDays[0].dayNumber;
      this.arrivalTimeSlots = response.data;
    });
  },
};
</script>

<style scoped>
.modal-content {
  font-size: 14px;
  max-width: 480px;
  padding-top: 120px;
  transform: translate(0, 20%);
}

.close-mobile {
  cursor: pointer;
}

.modal-content .header {
  display: flex;
  align-items: center;
  margin-bottom: 24px;
}

.modal-content .subtitle {
  font-style: normal;
  font-weight: 800;
  font-size: 20px;
  line-height: 30px;
  color: #ffffff;
  margin-left: 28px;
}

.modal-content .description {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 40px;
}

.modal-content .undertitle {
  margin-bottom: 16px;
}

.modal-content .result--error {
  color: #d73246;
}

.modal-content .result--success {
  color: #30cec2;
}

.modal-content .actions {
  margin-top: 28px;
}

.modal-content .form .actions .confirm-button:hover {
  background-color: #35e5d8;
}

.modal-content .actions .confirm-button {
  outline: none;
  border: none;
  border-radius: 15px;
  box-sizing: border-box;
  width: 100%;
  cursor: pointer;
  padding: 16px 0;
  background-color: #30cec2;
  transition: background-color 0.2s ease-in-out;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
}

.modal-content .actions .confirm-button:disabled {
  cursor: initial;
  opacity: 0.4;
}

.arrival-time-periods__days {
  margin-bottom: 40px;
}

.arrival-time-periods__days button {
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.8);
  box-sizing: border-box;
  border-radius: 20px;
  width: 88px;
  padding: 24px 0 18px;
  transition: border-color 0.2s ease-in-out;
  cursor: pointer;
}

.arrival-time-periods__days button.selected {
  border-color: #30cec2;
}

.arrival-time-periods__days button:not(:last-child) {
  margin-right: 16px;
}

.day-number {
  font-style: normal;
  font-weight: 800;
  font-size: 32px;
  line-height: 38px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.2s ease-in-out;
}

.day-string {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  transition: color 0.2s ease-in-out;
}

.selected .day-number,
.selected .day-string {
  color: #30cec2;
}

.arrival-time-periods {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.arrival-time-periods__slots {
  display: flex;
  flex-direction: column;
}

.arrival-time-periods__slots button {
  border: 0;
  background-color: transparent;
  border-bottom: thin solid rgba(255, 255, 255, 0.12);
  padding-top: 9px;
  padding-bottom: 12px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;
}

.arrival-time-periods__slots button:hover {
  background-color: rgba(255, 255, 255, 0.05);
}

.arrival-info {
  display: flex;
  flex-direction: column;
}

.arrival-info .time {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.87);
}

.arrival-info .amount {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: rgba(255, 255, 255, 0.6);
  text-align: left;
}

.arrival-mark {
  width: 20px;
  height: 20px;
  border: 1px solid #ffffff;
  box-sizing: border-box;
  margin-left: auto;
  border-radius: 50%;
  transition: border-color 0.2s ease-in-out;
  position: relative;
}

.arrival-mark.checked {
  border: 1px solid #30cec2;
}

.arrival-mark.checked::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #30cec2;
}
</style>
